export enum Hint {
  NEW_VISITOR = "new-visitor-v1",
  VISITOR_IN = "visitor-in-v1",
  NEW_LOCATION = "new-location-v1",
}
